import { Select } from '@livingdesign/react';
import React, { useState, useEffect } from 'react';
import { isUserAdmin } from '../../../../../../utils/user';
import { SENDER_CATEGORIES } from '../../../../../../consts/Campaign';

export const QA_ID_PREFIX = "FromFieldSelect";

function FromFieldSelect({
    value = null,
    onChange,
    onBlur,
    user,
    sendersList,
    name,
    label,
    style,
    error,
    disabled,
}) {
    
    const isAdmin = isUserAdmin(user);
    let currentSelection = sendersList?.find((sender) => sender.value === value);
    
    const options = isAdmin && !currentSelection && value
        ? [...sendersList, { category: SENDER_CATEGORIES.OTHER, value: value }]
        : sendersList;
    const [categorisedOptions, setCategorisedOptions] = useState({});
    const [selectedSender, setSelectedSender] = useState(
        options?.find((sender) => sender.value === value)
    );
    
    useEffect(() => {
        const categorisedOptions = options.reduce((acc, option) => {
            if (!acc[option.category]) {
                acc[option.category] = [];
            }
            acc[option.category].push(option);
            return acc;
        }, {});
        setCategorisedOptions(categorisedOptions);
    }, [options]);

    useEffect(() => {
        if (selectedSender?.value !== value) {
            onChange({target: {value: selectedSender?.value}});
        }
    }, [selectedSender]);
    
    return (
        <Select
            onChange={(e) => {
                if([null, "null", "Select a sender", "NOT_FOUND"].includes(e.target.value)) return;
                onChange(e);
            }}
            onBlur={onBlur}
            value={value}
            name={name}
            label={label}
            UNSAFE_style={style}
            error={error}
            disabled={disabled}
            data-testid={`${QA_ID_PREFIX}-select`}
        >
            <option value={null} data-testid={`${QA_ID_PREFIX}-option-default`}>Select a sender</option>
            {Object.keys(categorisedOptions).map((category, catIdx) => (
                <optgroup
                    key={category}
                    label={category}
                    data-testid={`${QA_ID_PREFIX}-optgroup-${catIdx}`}
                >
                    {categorisedOptions[category]?.map((sender, index) => (
                        <option
                            key={`${category}-${sender.value}-${index}`}
                            value={sender.value}
                            data-testid={`${QA_ID_PREFIX}-option-${catIdx}-${index}`}
                        >
                            {sender.value}
                        </option>
                    ))}
                </optgroup>
            ))}
        </Select>
    )
}

export default FromFieldSelect;